import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

const NAV: { to: string; label: string; adminOnly?: boolean }[] = [
  { to: '/', label: 'Dashboard' },
  { to: '/jobs', label: 'Jobs' },
  { to: '/interviews', label: 'Interviews' },
  { to: '/insights', label: 'Insights' },
  { to: '/services', label: 'Service pages', adminOnly: true },
  { to: '/sectors', label: 'Role pages', adminOnly: true },
  { to: '/faqs', label: 'FAQs', adminOnly: true },
  { to: '/team', label: 'Team', adminOnly: true },
  { to: '/logos', label: 'Logos', adminOnly: true },
  { to: '/testimonials/business', label: 'Business testimonials', adminOnly: true },
  { to: '/testimonials/candidate', label: 'Candidate testimonials', adminOnly: true },
  { to: '/users', label: 'Users', adminOnly: true },
  { to: '/settings', label: 'Settings', adminOnly: true },
];

export function Layout() {
  const { user, role, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = role === 'admin';

  return (
    <div className="d-flex" style={{ minHeight: '100vh' }}>
      <aside
        className="bg-white border-end p-3"
        style={{ width: 240, flexShrink: 0, position: 'sticky', top: 0, alignSelf: 'flex-start', height: '100vh', overflowY: 'auto' }}
      >
        <h5 className="text-green fw-bold mb-3">HRLabs Admin</h5>
        <nav className="nav flex-column">
          {NAV.filter((n) => !n.adminOnly || isAdmin).map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === '/'}
              className={({ isActive }) =>
                `nav-link px-2 py-1 ${isActive ? 'fw-bold text-green' : 'text-dark'}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <hr />
        <div className="small text-muted">{user?.email}</div>
        <div className="small text-muted mb-2">role: {role ?? '—'}</div>
        <button
          className="btn btn-sm btn-outline-secondary w-100"
          onClick={async () => {
            await logout();
            navigate('/login');
          }}
        >
          Log out
        </button>
      </aside>
      <main className="flex-grow-1 p-4" style={{ maxWidth: 1100 }}>
        <Outlet />
      </main>
    </div>
  );
}
